<div class="header-shell">
  <mat-toolbar class="header">
    <div class="header-left">
      <img src="/ewents-logo-navy.svg" alt="Ewents Logo" class="logo" />
    </div>

    <div class="header-center desktop-nav">
      @for (item of filteredMainMenuItems(); track item.label) {
        @if (!item.children?.length && item.route) {
          <a
            [routerLink]="item.route"
            routerLinkActive="active"
            #rla="routerLinkActive"
            class="menu-link"
            (mouseenter)="item.isHovered = true"
            (mouseleave)="item.isHovered = false"
          >
            <mat-icon
              class="icon"
              [svgIcon]="getMainMenuIcon(item, rla.isActive || item.isHovered)"
            ></mat-icon>
            <span class="label">{{ item.label | translate }}</span>
          </a>
        }
      }

      @if (companyMenuItem(); as company) {
        <button
          type="button"
          class="menu-link"
          [class.active]="isChildActive(company)"
          [matMenuTriggerFor]="companyMenu"
          (mouseenter)="company.isHovered = true"
          (mouseleave)="company.isHovered = false"
          aria-haspopup="menu"
          [attr.aria-label]="'nav.companyMenuAria' | translate"
        >
          <mat-icon
            class="icon"
            [svgIcon]="getMainMenuIcon(company, isChildActive(company) || company.isHovered)"
          ></mat-icon>
          <span class="label">{{ company.label | translate }}</span>
          <mat-icon class="icon menu-chevron" svgIcon="arrow-down"></mat-icon>
        </button>
        <mat-menu
          #companyMenu="matMenu"
          class="figma-dropdown-panel portal-company-menu"
          xPosition="before"
        >
          @for (child of company.children; track child.route) {
            <button
              type="button"
              mat-menu-item
              class="company-menu-item"
              [class.active]="isRouteActive(child.route)"
              (click)="navigateCompany(child.route)"
            >
              <mat-icon
                class="icon"
                [svgIcon]="getMainMenuIcon(child, isRouteActive(child.route))"
              ></mat-icon>
              <span>{{ child.label | translate }}</span>
            </button>
          }
        </mat-menu>
      }
    </div>

    <div class="header-right desktop-nav">
      <app-notification-bell />
      <a
        class="user-menu-trigger"
        routerLink="/profile"
        routerLinkActive="active"
        [ewentsTooltip]="getDisplayName()"
        ewentsTooltipPosition="below"
        [attr.aria-label]="'nav.profile' | translate"
      >
        <span class="user-pill">
          <app-avatar
            class="user-avatar"
            [avatarUrl]="currentUser?.avatarUrl ?? currentUser?.contact?.avatarUrl"
            [name]="getDisplayName()"
            [size]="32"
            shape="round"
            [alt]="getDisplayName()"
          ></app-avatar>
          <span class="user-name">{{ getDisplayName() }}</span>
        </span>
      </a>
      <a class="menu-link" (click)="onLogout()" [attr.aria-label]="'header.signOut' | translate">
        <mat-icon class="icon" svgIcon="logout"></mat-icon>
      </a>
    </div>

    <button
      type="button"
      class="mobile-menu-trigger mobile-nav"
      [class.is-open]="isMobileMenuOpen()"
      [attr.aria-expanded]="isMobileMenuOpen()"
      [attr.aria-label]="'header.openMenu' | translate"
      (click)="toggleMobileMenu()"
    >
      <mat-icon class="icon" svgIcon="header-menu"></mat-icon>
    </button>
  </mat-toolbar>

  @if (isMobileMenuOpen()) {
    <div
      class="mobile-menu-backdrop mobile-nav"
      (click)="closeMobileMenu()"
      aria-hidden="true"
    ></div>
    <nav class="mobile-menu-panel mobile-nav" [attr.aria-label]="'header.navMenuAria' | translate">
      @for (item of filteredMainMenuItems(); track item.label) {
        @if (!item.children?.length && item.route) {
          <a
            [routerLink]="item.route"
            routerLinkActive="active"
            #mobileRla="routerLinkActive"
            class="menu-link mobile-menu-link"
            (click)="onMobileNavClick()"
          >
            <mat-icon class="icon" [svgIcon]="getMainMenuIcon(item, mobileRla.isActive)"></mat-icon>
            <span class="label">{{ item.label | translate }}</span>
          </a>
        }
      }

      @if (companyMenuItem(); as company) {
        <button
          type="button"
          class="menu-link mobile-menu-link mobile-menu-section"
          [class.active]="isChildActive(company)"
          [attr.aria-expanded]="companySectionOpen()"
          (click)="toggleCompanySection()"
        >
          <mat-icon
            class="icon"
            [svgIcon]="getMainMenuIcon(company, isChildActive(company))"
          ></mat-icon>
          <span class="label">{{ company.label | translate }}</span>
          <mat-icon
            class="icon menu-chevron"
            [svgIcon]="companySectionOpen() ? 'arrow-up' : 'arrow-down'"
          ></mat-icon>
        </button>
        @if (companySectionOpen()) {
          <div class="mobile-submenu">
            @for (child of company.children; track child.route) {
              <a
                [routerLink]="child.route"
                routerLinkActive="active"
                #mobileChildRla="routerLinkActive"
                class="menu-link mobile-menu-link mobile-submenu-link"
                (click)="onMobileNavClick()"
              >
                <mat-icon
                  class="icon"
                  [svgIcon]="getMainMenuIcon(child, mobileChildRla.isActive)"
                ></mat-icon>
                <span class="label">{{ child.label | translate }}</span>
              </a>
            }
          </div>
        }
      }

      <div class="mobile-menu-bell">
        <app-notification-bell />
      </div>
      <a
        routerLink="/profile"
        routerLinkActive="active"
        class="menu-link mobile-menu-link"
        (click)="onMobileNavClick()"
      >
        <app-avatar
          class="user-avatar"
          [avatarUrl]="currentUser?.avatarUrl ?? currentUser?.contact?.avatarUrl"
          [name]="getDisplayName()"
          [size]="28"
          shape="round"
          [alt]="getDisplayName()"
        ></app-avatar>
        <span class="label">{{ getDisplayName() }}</span>
      </a>
      <button
        type="button"
        class="menu-link mobile-menu-link"
        (click)="onMobileLogout()"
        [attr.aria-label]="'header.signOut' | translate"
      >
        <mat-icon class="icon" svgIcon="logout"></mat-icon>
      </button>
    </nav>
  }
</div>
